import { logger } from '../../utilities/logger';
import { isEmptyArray } from '../../utilities/is_empty_array';
import { usePreferredLanguageContext } from '../../contexts/preferred_language/use_preferred_language_context';
import { useCustomEventListener } from '../../hooks/use_custom_event_listener';
import { errorChecker } from '../../utilities/error_checker';

const INVALID_LOCALE = 'Invalid locale';
const VALID_LOCALE = 0;

export const PREFERRED_LANGUAGE_EVENT_KEY = 'preferredLanguage';

export const parseLanguageTag = (locale: string) => {
  try {
    const parsed = Intl.getCanonicalLocales(locale);

    if (isEmptyArray(parsed)) {
      return INVALID_LOCALE;
    }
    return parsed[VALID_LOCALE];
  } catch (error) {
    logger.error({
      error: errorChecker(error),
      message: 'Invalid language tag',
      extra: { locale, error },
    });
    return INVALID_LOCALE;
  }
};

export const usePreferredLanguage = () => {
  const { setLanguage } = usePreferredLanguageContext();

  useCustomEventListener(PREFERRED_LANGUAGE_EVENT_KEY, (event) => {
    logger.debug({
      message: `${PREFERRED_LANGUAGE_EVENT_KEY} event received`,
      extra: { locale: event.detail.locale },
    });
    const newLocale = parseLanguageTag(event.detail.locale);

    if (newLocale === INVALID_LOCALE) {
      logger.warn({ message: 'Invalid language tag', extra: { locale: newLocale } });
    } else {
      setLanguage(newLocale);
      logger.debug({ message: 'Valid language tag set', extra: { locale: newLocale } });
    }
  });
};
